import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";

export const HowItWorksExampleMessage: React.FC = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "oceanWeatherIntelligence.sensorAlert",
  });

  return (
    <Box bg="rgba(209,217,226,0.32)" borderRadius="16px" p="10px">
      <Text
        fontSize="14px"
        fontWeight="600"
        color="#0884CC"
        lineHeight="20px"
        mb="24px"
      >
        {t("howItWorksExampleTitle")}
      </Text>
      <Flex
        flexDir="column"
        gap="0"
        fontSize="16px"
        color="#484848"
        lineHeight="20px"
      >
        <Text>
          {"⚠️ "}
          <Text as="strong" fontWeight="600">
            {t("howItWorksExampleLine1")}
          </Text>
        </Text>
        <Text mt="16px">
          <Text as="strong" fontWeight="600">
            {t("howItWorksExampleLine2Bold")}
          </Text>
          {t("howItWorksExampleLine2Rest")}
        </Text>
        <Text mt="16px">
          <Text as="strong" fontWeight="600">
            {t("howItWorksExampleLine3Label")}
          </Text>
        </Text>
        <Text>{t("howItWorksExampleLine3Item1")}</Text>
        <Text>{t("howItWorksExampleLine3Item2")}</Text>
        <Text mt="16px">{t("howItWorksExampleLine4")}</Text>
        <Text>{t("howItWorksExampleLine5")}</Text>
      </Flex>
    </Box>
  );
};
